import React from "react";
import { connect } from "react-redux";
import redux from "redux";

import { SecondaryMenuItem } from "./SecondaryMenuItem";
import { TreeBranch } from "../../models/navigation";
import { AppState } from "../../store";
import { List } from "immutable";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => {
    const branch = state.nav.branches.find((b) => b !== undefined && b.active && b.parentIds.length === 1);
    const branchId = branch ? branch.id : 0;

    return {
        currentPath: state.nav.currentPath,
        branch,
        branchChildren: state.nav.branches
            .filter((b) => b !== undefined && b.onNav && b.parentId === branchId)
            .sortBy((b) => b !== undefined && b.sort)
            .toList(),
    };
};

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
});

interface OwnProps {
}

interface ConnectedState {
    /**
     * this field is not used, but needed in order to refresh the state of this component
     * in order to render active nav links.
     */
    currentPath: string;
    branch: TreeBranch | undefined;
    branchChildren: List<TreeBranch | undefined>;
}

interface ConnectedDispatch {
}

interface OwnState {
}

export class SecondaryMenuComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public render() {
        if (!this.props.branch)
            return null;

        const navItems = this.props.branchChildren.map((item: TreeBranch, i) => {
            if (!item)
                return null;

            return (
                <SecondaryMenuItem
                    active={item.active}
                    id={item.id}
                    key={i || 0}
                    path={item.url}
                    separator={item.separator}
                    title={item.title}
                />
            );
        });

        return <div id="nav-secondary">
            <h3>{this.props.branch.title}</h3>
            <ul>
                {navItems}
            </ul>
        </div>;
    }
}

export const SecondaryMenu: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(SecondaryMenuComponent);



// WEBPACK FOOTER //
// ./src/components/navigation/SecondaryMenu.tsx